import React, { useEffect, useState } from 'react'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { deleteRequest, loadRequests } from '../../../store/Actions/ActionRequests'
import { ColumnRequests } from '../../../components/general/general-component/columns-component/ColumnRequests'
import { VariableRequests } from './VariableRequests'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../components/table/Table2'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import FilterRequest from './FilterRequest'
import Warning from '../../../components/general/general-component/warning-delete/Warning'

const fake = [
    {
        id: 1,
        request_date: "2024-04-15",
        received_by: "John Doe1",
        location: "Warehouse A"
    },
    {
        id: 2,
        request_date: "2024-04-15",
        received_by: "John Doe2",
        location: "Warehouse B"
    },
    {
        id: 3,
        request_date: "2024-04-15",
        received_by: "John Doe3",
        location: "Warehouse C"
    },
]
const Requests = ({setActiveSection,setActiveId}) => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { requests, loadingRequests } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit, setStateCustom } = VariableRequests()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [requestsArr, setRequestsArr] = useState(fake)
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...requestsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setRequestsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, requestsArr]);
    /*useEffect(() => {
        if (requests?.length >= 0) {
            setRequestsArr(requests)
        }
    }, [requests]);*/

    useEffect(() => {
        //dispatch(loadRequests())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteRequest(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openRequest = e => {
        e.preventDefault()
        navigate('/add-request')
    }
    const editRequest = (e,id) => {
        e.preventDefault()
        //navigate(`/requests/edit/${id}`)
        setActiveSection('Order')
        setActiveId(id)
    }
    const showRequest = (e,id) => {
        e.preventDefault()
        navigate(`/requests/${id}`)
    }
    const { columns } = ColumnRequests(translate, warning,showRequest, handleEdit,editRequest, langLocal)
    return (
        <>
            <main>
                <FilterRequest translate={translate} />
                {console.log(state)}
                <div className="div_table2" dir={langLocal == "ar" ? "rtl" : "ltr"} style={{ marginTop: "-24px" }} >
                    <SectionTopOfTable langLocal={langLocal} title={translate('requests')} titleBtn={translate('add_request')} FunctionBtn={openRequest} />
                    {/*
                        loadingWarehouses == false ? (
                            <Table2 col={columns} roo={warehousesArr} />
                        ) : <InnerLoader />
                        */}
                    <Table2 col={columns} roo={requestsArr} />
                </div>
                {
                    stateD.deletee == true ? (
                        <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                    ) : <></>
                }
            </main>
        </>
    )
}

export default Requests
